import { IOfferHandler } from '../../types';
import { CompleteBasketItem } from '../../../../providers/BasketProvider';
import useBogo from './useBogo';
import { Offer } from '../../../../services/exports/Interfaces';
import { useTranslation } from 'react-i18next';

const useBogoHalfPrice: IOfferHandler = () => {
  const { t } = useTranslation(null, { keyPrefix: 'Features:Offers:OfferBadge' });
  const bogoHandler = useBogo();
  const isEligibleItem = (offer: Offer, item: CompleteBasketItem): boolean =>
    offer.details.products.includes(item.entry.id) && item.quantity > 1;
  const getItemProfit = (item: CompleteBasketItem): number => {
    const discountedQty = Math.floor(item.quantity / 2) * 0.5;

    return discountedQty * item.entry.actual_price;
  };

  const getProfit = (offer: Offer, items: CompleteBasketItem[]): number => {
    if (!bogoHandler(offer, items).isEligible) {
      return 0;
    }

    return items.filter((item) => isEligibleItem(offer, item)).reduce((acc, item) => acc + getItemProfit(item), 0);
  };

  const apply =
    (offer: Offer) =>
    (item: CompleteBasketItem): CompleteBasketItem => {
      if (!item.actual_price) {
        return item;
      }

      if (!isEligibleItem(offer, item)) {
        return item;
      }

      const actualPrice = item.actual_price - getItemProfit(item);

      return {
        ...item,
        badges: [...item.badges, t(offer.kind)],
        actual_price: actualPrice,
      };
    };

  return (offer, items) => ({
    isUnlocked: true,
    isEligible: bogoHandler(offer, items).isEligible,
    profit: getProfit(offer, items),
    apply: apply(offer),
  });
};

export default useBogoHalfPrice;
